import type { ComponentPropsWithoutRef } from "react"

import type { CtaLink } from "~/types/cms"
import type { Theme } from "~/types/general"

import { PrimaryButton } from "./PrimaryButton"
import { SecondaryButton } from "./SecondaryButton"
import { TertiaryButton } from "./TertiaryButton"

export type ButtonVariant = "primary" | "secondary" | "tertiary"

type ButtonProps = {
  cta: CtaLink
  theme?: Theme
  className?: string
} & ComponentPropsWithoutRef<"a">

export const Button = ({
  cta,
  theme = "light",
  className = "",
  ...rest
}: ButtonProps) => {
  const variant = cta.variant || "primary"

  const renderButton = () => {
    const target = cta.target || rest.target
    switch (variant) {
      case "primary":
        return (
          <PrimaryButton
            target={target}
            cta={cta}
            theme={theme}
            className={className}
            {...rest}
          />
        )
      case "secondary":
        return (
          <SecondaryButton
            target={target}
            cta={cta}
            theme={theme}
            className={className}
            {...rest}
          />
        )
      case "tertiary":
        return (
          <TertiaryButton
            target={target}
            cta={cta}
            theme={theme}
            className={className}
            {...rest}
          />
        )
    }
  }

  return renderButton()
}
